<template>
  <div class="student_report_shengya">
    <div class="rzqn" style="margin-bottom: 10px">
      <div class="rzqnbox">
        <ul class="biaoContent">
          <li v-for="(item,index) in norm" :key="index">
            <div class="top">{{item.score}}</div>
            <div class="middle" :style="{
              bottom:(item.lnorm/200*371)+'px',
              height:(item.rnorm-item.lnorm)/200*371+'px'
            }">
            </div>
            <div class="bottom" :style="{height:item.score/200*414+'px'}">
            </div>
          </li>
        </ul>
        <p style="margin-top: 20px;color:#2F2F2F;position: absolute;bottom: 40px;width: 100%">认知潜能评估结果示意图</p>
      </div>
      <div class="rzqnTitle">认知潜能指标评估详细结果</div>
      <table>
        <tbody>
          <tr>
            <th>认知潜能</th>
            <th>潜能水平值</th>
            <th>常模范围</th>
            <th>出众百分比</th>
            <th width="70">非常低</th>
            <th width="70">比较低</th>
            <th width="70">一般</th>
            <th width="70">比较好</th>
            <th width="70">非常好</th>
          </tr>
          <tr v-for="(item,key) in norm">
              <td class="blue">{{item.name}}</td>
              <td>{{item.score}}</td>
            <td>{{item.lnorm}}~{{item.rnorm}}</td>
            <td>{{(item.percent*100).toFixed(2)}}%</td>
            <td colspan="5">
                <div
                  :style="{
                       width:item.percent<0.10&&'10%'||
                        item.percent>=0.10&&item.percent<0.25&&'30%'||
                        item.percent>=0.25&&item.percent<0.75&&'50%'||
                        item.percent>=0.75&&item.percent<0.90&&'70%'||
                        item.percent>=0.9&&'90%'
                  }"
                  :class="item.percent<0.10&&'b-red'||
                          item.percent>=0.10&&item.percent<0.25&&'b-orange'||
                          item.percent>=0.25&&item.percent<0.75&&'b-yellow'||
                          item.percent>=0.75&&item.percent<0.90&&'b-green'||
                          item.percent>=0.9&&'b-blue'"
                >
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "rzqn",
  props:['reportId'],
  data(){
    return {
      norm:[]
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_report + this.ports.consultant.student.report.rzqn,{
        report_id:this.reportId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==0){
          this.norm=res.data.result.norm
        }else{
        }
      })
    }
  },
  mounted() {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  @import '../../css/evaluationReport.less';
</style>